/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import React, { Component } from "react";

import {
  Input,
  Row,
  Col,
  notification,
  Modal,
  Button,
  message,
  Checkbox,
  Typography 
} from "antd";

import { Form } from "@ant-design/compatible";
import "./login.css";
import userIcon from "../images/UsernameIcon.png";
import lockIcon from "../images/lockIcon.png";
import ArrowIcon from "../images/loginarrow.png";
import MirraLogo from "../images/new_mirra_logo.png";
import cshLogo from '../images/ReportLogos/cshLogo.png';
import dotLogo from "../images/Dots.png";
import PersonsLogo from "../images/Doctor_Login.png";
import PageBackground from "../images/PageBackground.png";
import "antd/dist/reset.css";
import Config from "../../config";
import { Redirect } from "react-router-dom";
import Forgotmodal from "./Forgetpassword";
// import "antd/dist/antd.css";
// import "bootstrap/dist/css/bootstrap.min.css";
import Postdata from "./Postdata";
import showApplicationGuide from "./showApplicationGuide";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { RestFilled } from "@ant-design/icons";
import SurveyPopup from "../EligibilityCheck/SurveyPopup";
import EligibilityCheck from "../EligibilityCheck/EligibilityCheck";
//import { time } from "highcharts";
import axios from "axios";
const { Title } = Typography;

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      addModalShow: false,
      name: ["Kalos", "Dignity", "Valor", "Arkansas", "Liberty"],
      loader: false,
      show: false,
      TanentIDs: 0,
      IsSurveyPopupActive: false,
      SurveyLink: "",
      visible: false,
      showPopupModal: false,
      masedEmail: {},
      mfaCode: "",
      response: null,
      minutes: 0,
      seconds: 120,
      isCountdownComplete: false,
      isMFACodeValidated: false,
      isPauseMfa: false,
      isLoginDisabled: false,
      isResendClicked: false,
      CSHModelvisible: false,
      SolisModelVisible: false,
      UHPModelVisible: false,
    };
    this.showModalDisclaimer = this.showModalDisclaimer.bind(this);
  }

  showModalDisclaimer = () => {
    this.setState({
      visible: true,
    });
  };

  handleOkDisclaimer = (e) => {
    fetch(Config.api + "/UpdateFlag", {
      method: "post",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Email: sessionStorage.getItem("userEmail"),
        TenantID: sessionStorage.getItem("Tanent"),
        Flag: 1,
      }),
    });

    this.setState({
      visible: false,
    });

    this.setState({
      loader: false,
      isLoginDisabled: false,
    });

    //this.openNotification("Login Successfull");

    this.setState({ redirect: true });
  };

  handleCancelDisclaimer = (e) => {
    fetch(Config.api + "/UpdateFlag", {
      method: "post",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Email: sessionStorage.getItem("userEmail"),
        TenantID: sessionStorage.getItem("Tanent"),
        Flag: 0,
      }),
    });

    this.setState({
      visible: false,
    });

    this.setState({
      loader: false,
      isLoginDisabled: false,
    });

    this.openNotification("Please Accept disclaimer to login.");
    this.setState({ redirect: false });
  };

  getPauseMfa(planName) {
    fetch(`${Config.api}/isMfaEnabled?TenantName=${planName}`)
      .then((response) => response.json())
      .then((res) => {
        sessionStorage.setItem("loginMsg",res.loginMsg)
        this.setState({ isPauseMfa: res.isMfaEnabled });
      });
  }

  componentDidMount() {
    document.title = "Mirra HealthCare";
    const pathName = window.location.href;
    const url = "https://" + window.location.hostname;
    sessionStorage.setItem("url", url);
    //this.interval = setInterval(this.updateTimer, 1000);

    let planName;

    switch (
      true // pathName
    ) {
      case /kalos/i.test(pathName):
        planName = "kalos";
        break;
      case /arkss/i.test(pathName):
        planName = "arkss";
        break;
      case /valor/i.test(pathName):
        planName = "valor";
        break;
      case /liberty/i.test(pathName):
        planName = "liberty";
        break;
      case /demo/i.test(pathName):
        planName = "demo";
        break;
      case /dignity/i.test(pathName):
        planName = "dignity";
        break;
      case /ultimate/i.test(pathName):
        planName = "ultimate";
        break;
      case /podamerica/i.test(pathName):
        planName = "PodAmerica";
        break;
      case /sonder/i.test(pathName):
        planName = "sonder";
        break;
      case /solis/i.test(pathName):
        planName = "solis";
        break;
      case /chapters/i.test(pathName):
        planName = "chaptershospice";
        break;
      case /secur/i.test(pathName):
        planName = "secur";
        break;
        case /csh/i.test(pathName):
          planName = "csh";
          break;
      default:
        planName = "ultimate";
    }

    sessionStorage.setItem("planName", planName);
    //this.setState({ isSecurPlan: planName == "secur" });
    this.getPauseMfa(planName);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  startTimer = (otpTimeInSec) => {
    this.setState({
      seconds: otpTimeInSec % 60,
      minutes: Math.floor(otpTimeInSec / 60),
      isCountdownComplete: false,
    });

    this.interval = setInterval(this.updateTimer, 1000);
  };

  updateTimer = () => {
    const { minutes, seconds } = this.state;

    if (minutes === 0 && seconds === 0) {
      clearInterval(this.interval);
      this.setState({
        isCountdownComplete: true,
      });
      message.warning("MFA Code has expired.");
    } else {
      this.setState((prevState) => ({
        minutes:
          prevState.seconds === 0 ? prevState.minutes - 1 : prevState.minutes,
        seconds: prevState.seconds === 0 ? 59 : prevState.seconds - 1,
      }));
    }
  };

  // function to handle Cancel
  handleCancel = () => {
    this.setState({
      isCountdownComplete: false,
      showPopupModal: false, // hide popup
      mfaCode: "", // clear all priviously entered MFA code
      loader: false,
      isLoginDisabled: false,
    });
    clearInterval(this.interval);
  };
  handleNoticeModal = () => {
    this.setState({
      CSHModelvisible: false,
      SolisModelVisible: false,
      UHPModelVisible: false,
    })
  }

  getlatestNPITaxForIPA = () => {
    var Role = sessionStorage.getItem("rolename");
    if (Role.includes("IPA User")) {
      const requestBody = {
        PlanName: sessionStorage.getItem("planName"),
        IPAList: sessionStorage
          .getItem("IPAList")
          .split('"')
          .filter((ele) => {
            return ele !== "," && ele !== "";
          }),
      };
      fetch(
        Config.Providerapi +
          `/GetTaxIDandNPIDetailsByIPA?Planname=${sessionStorage.getItem(
            "planName"
          )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("access_token"),
          },
          body: JSON.stringify(requestBody),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          const data = res.Details;
          let tempObj = {};
          data.forEach((ele) => {
            if (!tempObj[ele.groupTaxId]) tempObj[ele.groupTaxId] = { NPI: [] };
            if (ele.groupNPI)
              tempObj[ele.groupTaxId].NPI.push(ele.groupNPI.toString());
            if (ele.npiNumber)
              tempObj[ele.groupTaxId].NPI.push(ele.npiNumber.toString());
          });

          let latesttaxIDNPIMapping = Object.keys(tempObj).map((ele) => {
            return {
              TaxID: ele,
              NPI: tempObj[ele].NPI,
            };
          });

          sessionStorage.setItem(
            "latestTaxidNpiMapping",
            JSON.stringify(latesttaxIDNPIMapping)
          );
        });
    }
  };

  showModel = () => {
    fetch(
      `${Config.api}/GetTenantIDByName?TenantName=${sessionStorage.getItem(
        "planName"
      )}`
    )
      .then((response) => response.json())
      .then((res) => {
        localStorage.setItem("IsSurveyPopupActive", res.IsSurveyPopupActive);
        localStorage.setItem("SurveyLink", res.SurveyLink);
        localStorage.setItem("IsHRAPopupActive", res.IsHRAPopupActive);
        // console.log(res);
        this.setState({
          TanentIDs: res.TenantID,
          IsSurveyPopupActive: res.IsSurveyPopupActive,
          SurveyLink: res.SurveyLink,
        });
        let Tanentid = res.TenantID;
        Tanentid = parseInt(Tanentid, 10);
        sessionStorage.setItem("Tanent", this.state.TanentIDs);
      });
    this.setState({
      ...this.state,
      show: !this.state.show,
    });
  };

  logout = () => {
    sessionStorage.setItem("userData", "");
    sessionStorage.clear();
    this.setState({ redirect: true });
    Swal.fire({
      text: "Your session has been expired !",
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: "OK",
      confirmButtonColor: "#2a3ba4",
    }).then(() => {
      window.location.pathname = "/login";
    });
  };

  refreshtoken = () => {
    let formDatarefresh = {
      refresh_token: sessionStorage.getItem("refresh_token"),
      grant_type: "refresh_token",
    };
    const encodeFormData = (data) => {
      return Object.keys(data)
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
        )
        .join("&");
    };
    fetch(Config.api + "/getToken", {
      method: "POST",
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
      },
      body: encodeFormData(formDatarefresh),
    })
      .then((res) => res.json())
      .then((responsejson) => {
        sessionStorage.setItem("access_token", responsejson.access_token);
        sessionStorage.setItem("token_type", responsejson.token_type);
        sessionStorage.setItem("expires_in", responsejson.expires_in);
        sessionStorage.setItem("refresh_token", responsejson.refresh_token);
      });
  };

  getCSNPPendingFlag = async ( ) => {
    try {
      this.setState({ SearchLoading: true, isPageSearch: false });
      var mappingDataString = sessionStorage.getItem("taxidNpiMapping");
      let formattedData = [];

      if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
        console.log("inside provider");
        const npi = JSON.parse(sessionStorage.getItem("npivalue"))[0];
        const taxids = JSON.parse(sessionStorage.getItem("taxid")) || [];

        formattedData = taxids.map((taxid) => ({
          TaxID: taxid,
          NPI: npi || null,
        }));
      }
      // Check role
      const roleName = sessionStorage.getItem("rolename") || "";

      if (roleName.includes("Group User") || roleName.includes("IPA User")) {
        console.log("inside Gourp");
        // Choose the correct mapping based on role
        const mappingKey = roleName.includes("IPA User")
          ? "latestTaxidNpiMapping"
          : "taxidNpiMapping";

        const taxidNpiMapping =
          JSON.parse(sessionStorage.getItem(mappingKey)) || [];

        // Transform it into desired structure
        formattedData = taxidNpiMapping.flatMap((item) =>
          (item.NPI || []).map((npi) => ({
            TaxID: item.TaxID || null,
            NPI: npi,
          }))
        );
      }

      // Remove duplicate TaxID + NPI combinations
      formattedData = Array.from(
        new Map(
          formattedData.map((item) => [`${item.TaxID}|${item.NPI}`, item])
        ).values()
      );

      console.log("Unique Formatted Data:", formattedData);
      // You can now send `formattedData` in your payload
      console.log("Formatted Data:", formattedData);
      
      console.log("mappingData", mappingDataString);
      var npiArray = [];
      if (mappingDataString) {
        try {
          var mappingData = JSON.parse(mappingDataString); // <-- Parse JSON string to array
          mappingData.forEach((item) => {
            if (Array.isArray(item.NPI)) {
              item.NPI.forEach((npi) => npiArray.push(npi));
            }
          });
          console.log("npiArray:", npiArray);
        } catch (e) {
          console.error("Failed to parse mappingData", e);
        }
      } else {
        npiArray = JSON.parse(sessionStorage.getItem("npivalue"));
        console.log(npiArray);
      }
      console.log("mapping@@#", mappingDataString);
      console.log("!!!!!", sessionStorage.getItem("taxid"));
      let response = await fetch(`${Config.Enrolment}/GetPendingAttestationFlag`, {
        method: "POST",
        headers: {
          Authorization: localStorage.getItem("CNPtoken"), // <-- Using the token from getAuthToken
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageSize: 10,
          pageNumber:1,
          providerDetails: formattedData,   
          // providerNPI: ["1003042581"],
          subsciberId: null, // <- set search box value,
          mbi: null,
          memberName: null,
          attestationType:  null,
          applicationDate: null,
          attestationDate: null,
          attestedBy: null,
          pcpName: [],
          status: null,
          effectiveDate:  null,
          planname: sessionStorage.getItem("planName"),
          custId:
            sessionStorage.getItem("planName") === "liberty"
              ? "101"
              : parseInt(sessionStorage.getItem("Tanent")),
          userName: sessionStorage.getItem("userName"),
        }),
      })

      const data = await response.json();
      sessionStorage.setItem("IsCSNPPendingLoading", "false");
      localStorage.setItem('IsCSNPPending',data?.isCSNPPending);
      localStorage.setItem('IsCSNPPendingPopupActive',data?.isCSNPPending);
      localStorage.setItem('IsSSBCIPending',data?.isSSBCIPending);
      localStorage.setItem('IsSSBCIPendingPopupActive',data?.isSSBCIPending);
      window.dispatchEvent(
        new CustomEvent("csnpResponseReceived", {
          detail: {
            isCSNPLoading: false,
          }
        })
      );
    } catch (error) {
      console.error("Failed to fetch CSNP data:", error);
    }
  };
  // Step 1: Fetch Auth Token and save in localStorage
  getAuthToken = async () => {
    sessionStorage.setItem('IsCSNPPendingLoading',"true");
    window.dispatchEvent(
      new CustomEvent("csnpLoadingStatus", {
        detail: { isCSNPLoading: true }
      })
    );

    try {
      const response = await fetch(`${Config.Enrolment}/GetAuthToken`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CustID:
            sessionStorage.getItem("planName") === "liberty"
              ? "101"
              : String(sessionStorage.getItem("Tanent")),
          PlanName: sessionStorage.getItem("planName"),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        //console.log("Token Received:", data.TokenInfo.token);

        localStorage.setItem("CNPtoken", data.TokenInfo.token);
        this.getCSNPPendingFlag();
      } else {
        console.error("Failed to fetch authentication token");
      }
    } catch (error) {
      console.error("Error fetching authentication token:", error);
      throw error;
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    clearInterval(this.interval);
    this.props.form.validateFieldsAndScroll(
      ["Email", "Password", "isRememberMe"],
      (err, values) => {
        console.log(values);

        if (values.Email === null || values.Password === null) {
          this.setState({
            loader: false,
            isLoginDisabled: false,
          });
        }
        if (!err) {
          this.setState({
            loader: true,
            isLoginDisabled: true,
          });

          localStorage.setItem("isRememberMe", values.isRememberMe);
          fetch(
            `${
              Config.api
            }/GetTenantIDByName?TenantName=${sessionStorage.getItem(
              "planName"
            )}`
          )
            .then((response) => response.json())
            .then((res) => {
              console.log(res);
              localStorage.setItem(
                "IsSurveyPopupActive",
                res.IsSurveyPopupActive
              );
              localStorage.setItem("IsCSNPActive", res.IsCSNPActive);
              localStorage.setItem("SurveyLink", res.SurveyLink);
              localStorage.setItem("IsHRAPopupActive", res.IsHRAPopupActive);
              this.setState({
                TanentIDs: res.TenantID,
                IsSurveyPopupActive: res.IsSurveyPopupActive,
                SurveyLink: res.SurveyLink,
              });
              let Tanentid = res.TenantID;
              Tanentid = parseInt(Tanentid, 10);
              sessionStorage.setItem("Tanent", this.state.TanentIDs);

              let formData = {
                username: values.Email + "_" + Tanentid,
                password: values.Password,
                grant_type: "password",
                User: values.Email,
                isRememberMe: localStorage.getItem("isRememberMe") === "true",
              };
              const encodeFormData = (data) => {
                return Object.keys(data)
                  .map(
                    (key) =>
                      encodeURIComponent(key) +
                      "=" +
                      encodeURIComponent(data[key])
                  )
                  .join("&");
              };
              fetch(Config.api + "/getToken", {
                method: "POST",
                headers: {
                  "Content-type": "application/x-www-form-urlencoded",
                },
                body: encodeFormData(formData),
              })
                .then((response) => {
                  if (response.status === 500) {  // 500 bcz system outage is giving 500 error
                    this.setState({
                      CSHModelvisible: sessionStorage.getItem("planName") === "csh" || sessionStorage.getItem("planName") === "secur" ? true : false,
                      SolisModelVisible: sessionStorage.getItem("planName") === "solis" ? true : false,
                      UHPModelVisible: sessionStorage.getItem("planName") === "ultimate" ? true : false,
                      loader: false,
                      isLoginDisabled: false,
                    })
                  }
                  return response.json()
                })
                .then((responsejson) => {
                  // if (responsejson.MFADetails?.isMfaEnabled === true) {
                  //   this.setState({
                  //     showPopupModal: responsejson.MFADetails?.isOtpMailSent, // true
                  //     masedEmail: responsejson.MFADetails.masedEmail, // email ID
                  //     timer: responsejson.MFADetails.otpTimeInSec, // otp time 120 second
                  //     seconds: responsejson.MFADetails.otpTimeInSec % 60, // formula to change 120 seconds as 2 min 0 sec
                  //     minutes: Math.floor(
                  //       responsejson.MFADetails.otpTimeInSec / 60 // formula to change 120 seconds as 2 min 0 sec
                  //     ),
                  //   });
                  // } else {
                  //   this.setState({
                  //     isMFACodeValidated: true,
                  //   });
                  // }
                  if (responsejson.error == "invalid_credentials") {
                    this.openNotification(
                      responsejson.error_description
                    );
                    this.setState({
                      loader: false,
                      isLoginDisabled: false,
                    });
                  }

                  sessionStorage.setItem(
                    "access_token",
                    responsejson.access_token
                  );
                  sessionStorage.setItem("token_type", responsejson.token_type);
                  sessionStorage.setItem("expires_in", responsejson.expires_in);
                  sessionStorage.setItem(
                    "refresh_token",
                    responsejson.refresh_token
                  );

                  setInterval(() => {
                    this.refreshtoken();
                  }, 1500000);
                  if (
                    responsejson.error === "invalid_grant" ||
                    responsejson.error === "user_deactivated"
                  ) {
                    this.setState({
                      loader: false,
                      isLoginDisabled: false,
                    });
                    this.openNotification(responsejson.error_description);
                  } else {
                    if (sessionStorage.getItem("access_token") != undefined) {
                      sessionStorage.setItem('IsCSNPPendingLoading',"true");
                      window.dispatchEvent(
                        new CustomEvent("csnpLoadingStatus", {
                          detail: { isCSNPLoading: true }
                          })
                          );
                      Postdata(values.Email).then((Result) => {
                        console.log("result", Result);
                        let responseJSON = Result;
                        if (
                          responseJSON.LoginInfo.Message === "Login Successful"
                        ) {
                          // if(responseJSON){
                          sessionStorage.setItem("userData", responseJSON);
                          sessionStorage.setItem("userEmail", values.Email);
                          sessionStorage.setItem(
                            "userName",
                            responseJSON.LoginInfo.UserName
                          );
                          sessionStorage.setItem(
                            "UserID",
                            responseJSON.LoginInfo.UserID
                          );
                          sessionStorage.setItem(
                            "EligibilityOnlyFlag",
                            responseJSON.EligibilityOnlyFlag
                          );

                          sessionStorage.setItem(
                            "phoneNumber",
                            responseJSON.LoginInfo.PhoneNumber
                          );

                          // var Role = sessionStorage.setItem("rolename",responseJSON.LoginInfo.RoleName)
                          var Role = responseJSON.LoginInfo.RoleName;
                          sessionStorage.setItem("rolename", Role);
                          var isadmin = Role.includes("User Admin");
                          var isProvider = Role.includes("Provider");
                          var isPlanAdmin = Role.includes("Plan Admin");
                          this.getlatestNPITaxForIPA();
                          if (isadmin && isProvider) {
                            sessionStorage.setItem("ProviderRole", "PROVIDER");
                            sessionStorage.setItem("AdminRole", "User Admin");
                          } else if (isadmin && isPlanAdmin) {
                            sessionStorage.setItem("AdminRole", "User Admin");
                            sessionStorage.setItem(
                              "PlanAdminRole",
                              "Plan Admin"
                            );
                          } else if (isadmin) {
                            sessionStorage.setItem("AdminRole", "User Admin");
                          } else if (isProvider) {
                            sessionStorage.setItem("ProviderRole", "PROVIDER");
                          } else {
                            sessionStorage.setItem(
                              "PlanAdminRole",
                              "Plan Admin"
                            );
                          }
                          // For Claims Table
                          var planname = sessionStorage.setItem(
                            "Plan",
                            this.state.name
                          );
                          sessionStorage.setItem("pname", planname);

                          responseJSON.NpiDetails &&
                            responseJSON.NpiDetails.length > 0 &&
                            sessionStorage.setItem(
                              "npivalue",
                              JSON.stringify(responseJSON.NpiDetails)
                            );

                          responseJSON.TaxDeatils &&
                            responseJSON.TaxDeatils.length > 0 &&
                            sessionStorage.setItem(
                              "taxid",
                              JSON.stringify(responseJSON.TaxDeatils)
                            );

                          if (
                            responseJSON.TAXIDNPIMapping &&
                            responseJSON.TAXIDNPIMapping.length > 0
                          )
                            sessionStorage.setItem(
                              "taxidNpiMapping",
                              JSON.stringify(responseJSON.TAXIDNPIMapping)
                            );

                          var flag = responseJSON.Flag;
                          console.log(flag);
                          console.log(
                            "responsejson.MFADetails: ",
                            responsejson.MFADetails
                          );
                          if (responsejson.MFADetails?.isMfaEnabled === true) {
                            this.setState({
                              showPopupModal: true, // true
                              masedEmail: responsejson.MFADetails.masedEmail, // email ID
                              // timer: responsejson.MFADetails.otpTimeInSec, // otp time 120 second
                              // seconds:
                              //   responsejson.MFADetails.otpTimeInSec % 60, // formula to change 120 seconds as 2 min 0 sec
                              // minutes: Math.floor(
                              //   responsejson.MFADetails.otpTimeInSec / 60 // formula to change 120 seconds as 2 min 0 sec
                              // ),
                            });
                            this.startTimer(
                              responsejson.MFADetails.otpTimeInSec
                            );
                          }
                          if (
                            responsejson.MFADetails?.isMfaEnabled === false ||
                            responsejson.MFADetails === null
                          ) {
                            this.setState({
                              isMFACodeValidated: true,
                              showPopupModal: false,
                              redirect: true,
                            });
                          }
                          if (flag === false) {
                            this.showModalDisclaimer();
                          } else if (flag === true) {
                            // this.openNotification(
                            //   responseJSON.LoginInfo.Message
                            // );
                            //this.setState({ redirect: true });
                          } else {
                            this.openNotification("Couldn't Login");
                          }
                          this.getAuthToken();
                          // setTimeout(() => {
                          //   this.logout();
                          // }, 1799000);
                        } else {
                          if (
                            responseJSON.ErrorMessage ===
                            "Access Denied for getLoginInformation API"
                          ) {
                            this.setState({
                              loader: false,
                              isLoginDisabled: false,
                            });
                            this.openNotification(
                              "The user name or password is incorrect."
                            );
                          } else
                            this.openNotification(
                              responseJSON.ErrorMessage ===
                                "Access Denied for getLoginInformation API"
                            );
                        }
                        // to call the application Guide download API
                        showApplicationGuide().then(() => {});
                      });
                    } else {
                      this.openNotification(
                        "The user name or password is incorrect."
                      );
                    }
                  }
                 //  this.getAuthToken();
                });
            });
        }
      }
    );
  };

  openNotification = (res) => {
    notification.open({
      description: res,
    });
  };

  // function to hold entered MFA CODE
  handleMfaCodeChange = (event) => {
    this.setState({
      mfaCode: event.target.value,
    });
    console.log(event.target.value);
  };

  // function to resend MFA code
  handleResendMFA = (e) => {
    if (this.state.isResendClicked) {
      e.preventDefault();
      return;
    }
    this.setState({ isResendClicked: true });
    // Define the data you want to send in the request body
    const requestData = {
      email: sessionStorage.getItem("userEmail"),
      name: sessionStorage.getItem("userName"),
      tenantId: sessionStorage.getItem("Tanent"),
    };

    // Make the API call using the fetch function
    fetch(`${Config.api}/ResendOtp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (response.status === 200) {
          // Handle success
          response
            .json() // Parse the response as JSON
            .then((data) => {
              this.setState({ isResendClicked: false });
              console.log("MFA code resent successfully.", data.otpTimeInSec);
              this.startTimer(data.otpTimeInSec);
            });
        } else {
          // Handle error
          this.setState({ isResendClicked: false });
          console.error("Failed to resend MFA code.");
        }
      })
      .catch((error) => {
        // Handle network error
        this.setState({ isResendClicked: false });
        console.error("Network error:", error);
      });
  };

  // function to verify enter otp
  handleVerifyOTP = () => {
    const data = {
      otpcode: this.state.mfaCode,
      email: sessionStorage.getItem("userEmail"),
      tenantId: sessionStorage.getItem("Tanent"),
      isRememberMe: localStorage.getItem("isRememberMe") === "true",
    };

    axios
      .post(`${Config.api}/VerifyOtp`, data) // Change the URL as needed
      .then((response) => {
        //  setResponse(response.data);
        console.log("rr", response.data.Message);
        if (response.data.Message === "OTP validated successfully") {
          this.setState({
            isMFACodeValidated: true,
            showPopupModal: false,
            redirect: true,
          });
          this.openNotification("Login Successfull");
        } else if (
          response.data.message === "Invalid OTP entered, please try again"
        ) {
          console.log("INside error");
          this.openNotification(
            "Invalid OTP entered, please try again",
            "red",
            true
          );
        } else {
          this.openNotification(
            "Invalid OTP entered, please try again",
            "red",
            true
          );
        }
      })
      .catch((error) => {
        //  setError(error);
      });
    // setShowModal(false)
  };

  checkNoGroupUsers = () => {
    let roles = sessionStorage.getItem("rolename");
    return (
      roles &&
      !sessionStorage.getItem("rolename").includes("Group User") &&
      !sessionStorage.getItem("rolename").includes("IPA User")
    );
  };
  handleRegisterClick = () => {
    const { setLoading, history } = this.props;
    console.log("Register Now button clicked"); // Debug log

    setLoading(true); // Start the loader
    history.push("/Registration"); // Navigate to the Registration page
  };

  render() {
    const { isPauseMfa } = this.state;
    // console.log(this.state.TanentIDs, sessionStorage.getItem("ProviderRole"));
    // if (this.state.redirect) {
    //   if (
    //     sessionStorage.getItem("AdminRole") &&
    //     sessionStorage.getItem("ProviderRole")
    //   ) {
    //     return <Redirect to={"/EligibilityCheck"} />;
    //   } else if (sessionStorage.getItem("ProviderRole")) {
    //     return <Redirect to={"/EligibilityCheck"} />;
    //   } else {
    //     return <Redirect to={"/userDetails"} />;
    //   }
    // }
    if (this.state.redirect && this.state.isMFACodeValidated == true) {
      if (
        sessionStorage.getItem("AdminRole") &&
        sessionStorage.getItem("ProviderRole") === null &&
        sessionStorage.getItem("PlanAdminRole") === null &&
        this.checkNoGroupUsers()
      ) {
        return <Redirect to={"/userDetails"} />; // for User Admin role only
      }
      // else if (
      //   sessionStorage.getItem("AdminRole") &&
      //   (sessionStorage.getItem("ProviderRole") === null ||
      //     this.checkNoGroupUsers() ||
      //     sessionStorage.getItem("PlanAdminRole") === null)
      // ) {
      //   return <Redirect to={"/EligibilityCheck"} />;
      // }
      else if(sessionStorage.getItem("planName") === "csh"){
        return <Redirect to={"/EligibilityCheck"} />;
      }
      else {
        return <Redirect to={"/Search_member"} />;
      }
    }

    // if (sessionStorage.getItem("userData")) {
    //   return <Redirect to={"/EligibilityCheck"} />;
    // }
    if (sessionStorage.getItem("")) {
      return <Redirect to={"/login"} />;
    }
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        xl: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        xl: { span: 24 },
      },
    };

    const { getFieldDecorator } = this.props.form;

    return (
      <>
        <Modal
  title="Portal Unavailable"
  open={this.state.SolisModelVisible}
  footer={null}
  centered
  width={900}   // 🔹 Increased width (change to 1000 if needed)
  onCancel={this.handleNoticeModal}
  maskClosable={false} // Prevent closing by clicking outside
>
  <div style={{ maxHeight: "400px", overflowY: "auto", fontSize: "16px", lineHeight: "1.6" }}>
    <p>
      The Portal is currently unavailable. Please rest assured that we are actively working to resolve the issue and restore access as quickly as possible.
    </p>

    <p>
      In the meantime, please follow the steps outlined below to ensure there is no disruption to patient care. Paper forms can be found at:{" "}
      <a
        href="https://solishealthplans.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        solishealthplans.com
      </a>{" "}
      under Provider Resources/Documents & Forms
    </p>

    <h4>Authorizations</h4>
    <p>Please complete a paper Authorization Service Request Form. Once completed, this form can be sent via fax:</p>
    <ul>
      <li>General Authorizations: 833-210-8141</li>
      <li>Inpatient: 833-210-8142</li>
      <li>CCR: 833-846-0895</li>
    </ul>

    <p>
      For questions related to authorizations, please call: <strong>833-615-9260</strong>
    </p>

    <h4>Referrals</h4>
    <p>Please complete a paper Referral Form. Once completed, this form can be sent via fax to:</p>
    <ul>
      <li>833-846-0896</li>
    </ul>

    <h4>CSNP and SSBCI Attestations</h4>
    <p>
      Please continue working directly with your Provider Representative regarding these documents.
    </p>

    <p>
      Any questions? Please reach out to your Solis Provider Representative, or email us at:{" "}
      <a href="mailto:providerrelations@solishealthplans.com">
        providerrelations@solishealthplans.com
      </a>{" "}
      or call us at <strong>833-615-9259</strong>
    </p>
  </div>
</Modal>
<Modal
  title="Temporary Service Outage"
  open={this.state.CSHModelvisible}
  footer={null}
  centered
  width={750}
  onCancel={this.handleNoticeModal}
  //closable={false} // Hide the close icon
  maskClosable={false} // Prevent closing by clicking outside
>
  <div style={{ fontSize: "16px", lineHeight: "1.6" }}>
  <p>
    We are currently experiencing a temporary service outage affecting our provider portal and claims systems.
  </p>

  <p>
    Our technical team is working diligently to restore full functionality.
  </p>

  <p>
    We apologize for any inconvenience this may cause and appreciate your patience.
  </p>
  <p>
    If you need assistance, please call our customer service team at{" "}
    <a href="tel:+18773644566">
      1-877-364-4566
    </a>{" "} for support.
  </p>
  </div>
</Modal>
<Modal
  title="Provider Portal Service Outage"
  open={this.state.UHPModelVisible}   // use visible if using AntD v4
  footer={null}
  centered
  width={750}
  onCancel={this.handleNoticeModal}
>
  <div style={{ fontSize: "16px", lineHeight: "1.6" }}>
    <p>
      Ultimate Health Plans is currently experiencing a temporary service outage affecting the Provider Portal.
      Our technical team is actively working to restore full functionality as quickly as possible.
    </p>

    <p>
      We sincerely apologize for any inconvenience this may cause and appreciate your patience while this issue is being resolved.
    </p>

    <p>
      In the meantime, if you need assistance with <b>Prior Authorization status</b> or <b>Member Eligibility verification</b>,
      please contact our Provider Relations team at{" "}
      <a href="mailto:Provider_Relations@ulthp.com">
        Provider_Relations@ulthp.com
      </a>.
    </p>
  </div>
</Modal>

        <Modal
          title="Multi-factor Authentication"
          open={this.state.showPopupModal}
          onOk={this.handleCancel}
          onCancel={this.handleCancel}
          footer={null}
          closable={false} // Hide the close icon
          maskClosable={false} // Prevent closing by clicking outside
        >
          <Input
            placeholder="Textbox 1"
            value={this.state.masedEmail}
            style={{ marginBottom: 16 }}
            readOnly
          />
          <Input
            placeholder="Enter MFA Code"
            style={{ marginBottom: 16 }}
            value={this.state.mfaCode}
            onChange={this.handleMfaCodeChange}
          />
          {/* <div>
      <p>MFA Code has expired, please click on <a onClick={this.handleResendMFA} style={{ color: 'blue' }}>Resend MFA Code</a> to
          send a new MFA Code.</p>
      </div> */}

          {/* Modal content goes here */}
          {this.state.isCountdownComplete ? (
            <div>
              <p>
                MFA Code has expired. Please click on{" "}
                <a onClick={this.handleResendMFA} style={{ color: "blue", cursor: this.state.isResendClicked ? 'not-allowed' : 'pointer' }}>
                  Resend MFA Code
                </a>{" "}
                to send a new MFA Code.
              </p>
            </div>
          ) : (
            <div>
              <p>
                MFA Code will expire in {this.state.minutes} mins and{" "}
                {this.state.seconds} seconds
              </p>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              key="submit"
              onClick={this.handleVerifyOTP}
              type="primary"
              style={{ width: "70%", marginBottom: 16 }}
              disabled={this.state.mfaCode === ""} // Disable the button if mfaCode is empty
            >
              Submit
            </Button>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              key="cancel"
              type="default"
              onClick={this.handleCancel}
              style={{
                width: "70%",
                backgroundColor: "red",
                color: "white",
                border: "none",
                marginBottom: 16,
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal>

        <div className="body">
          <img
            src={PageBackground}
            alt="Background Logo"
            className="background-image"
          />
          <Row>
            <Col span={24}>
              <div className="mirralogo">
                <img
                  src={sessionStorage.getItem("planName") === "csh" ? cshLogo : MirraLogo}
                  alt="Mirra Logo"
                  width="90"
                  height="97"
                  className={
                    sessionStorage.getItem("planName") === "csh"
                      ? "cshlogo-img"
                      : "mirralogo-img"
                  }
                />
              </div>
            </Col>
          </Row>

          <div className="container">
            <div className="container-left">
              <div className="welcomeText">Welcome to</div>
              <div>
                <span className="censusText">Provider Portal</span>
                {/* <img
                src={dotLogo}
                alt="Dots Logo"
                width="42"
                height="44"
                className="dotslogo"
              /> */}
              </div>
              <div>
                <img
                  src={PersonsLogo}
                  alt="Persons Logo"
                  width="400"
                  height="280"
                />
              </div>
              
              <div className="supportTextBox">
                {(() => {
                  const loginMsg = sessionStorage.getItem("loginMsg");

                  if (!loginMsg || loginMsg === "undefined") {
                    return "For login assistance, please contact the Health Plan.";
                  }

                  const updatedMsg = loginMsg.replace(
                    /href=(["'])(?!mailto:)([^"']+@[^"']+)\1/gi,
                    'href="mailto:$2"'
                  );

                  return (
                    <span
                      dangerouslySetInnerHTML={{ __html: updatedMsg }}
                    />
                  );
                })()}
              </div>

            </div>
            <div className="formStyle">
              <div className="container-right">
                <Row>
                  <Col span={24}>
                    <div className="userLoginText">User Login</div>
                  </Col>
                </Row>
                <div>
                  <Form
                    //onSubmit={this.handleSubmit}
                    {...formItemLayout}
                    // initialValues={{ remember: true }}
                  >
                    <Row>
                      <Col span={24}>
                        <div className="mb-2">
                          <span className="userIcon">
                            <img
                              src={userIcon}
                              width="14"
                              height="18"
                              alt="User Icon"
                            />
                          </span>
                          <span className="usernameText ml-2">Username</span>
                        </div>

                        <Form.Item>
                          {getFieldDecorator("Email", {
                            // initialValue: this.state.EMail,
                            rules: [
                              {
                                required: true,
                                type: "email",
                                message: (
                                  <span style={{ fontSize: "10px" }}>
                                    Please enter valid Email
                                  </span>
                                ),
                              },
                            ],
                          })(
                            <Input
                              placeholder="Enter Email"
                              onChange={this.emailChange}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <div className="mb-2" style={{ marginTop: "20px" }}>
                          <span className="lockIcon">
                            <img
                              src={lockIcon}
                              alt="Lock Icon"
                              width="12"
                              height="18"
                            />
                          </span>
                          <span className="passwordText ml-2">Password</span>
                        </div>
                        <Form.Item>
                          {getFieldDecorator("Password", {
                            // initialValue: this.state.Password,
                            rules: [
                              {
                                required: true,
                                message: (
                                  <span style={{ fontSize: "10px" }}>
                                    Please enter valid password
                                  </span>
                                ),
                              },
                            ],
                          })(
                            <Input.Password
                              type="password"
                              placeholder="Enter Password"
                              onChange={this.passwordChange}
                            />
                          )}
                        </Form.Item>
                        <a
                          className="login-form-forgot"
                          onClick={this.showModel}
                          href="#"
                        >
                          Forgot password?
                        </a>
                      </Col>

                      <Col span={24} hidden>
                        <div className="mb-2">
                          <span className="lockIcon">
                            <img
                              src={lockIcon}
                              alt="Lock Icon"
                              width="12"
                              height="18"
                            />
                          </span>
                          <span className="passwordText ml-2">Tanent</span>
                        </div>
                        <Form.Item>
                          {getFieldDecorator("TenantID", {
                            initialValue: sessionStorage.getItem("Tanent"),
                            // initialValue: this.state.TenantID,
                            rules: [
                              {
                                required: false,
                              },
                            ],
                          })(
                            <Input.Password
                              type="password"
                              placeholder="Enter Password"
                              // onChange={this.passwordChange}
                            />
                          )}
                        </Form.Item>
                        <a
                          className="login-form-forgot"
                          onClick={this.showModel}
                          href="#"
                        >
                          Forgot password?
                        </a>
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "-30px" }}>
                      <Col span={24}>
                        <Form.Item>
                          {isPauseMfa &&
                            getFieldDecorator("isRememberMe", {
                              initialValue: false,
                            })(<Checkbox className="mb-0">Pause MFA</Checkbox>)}
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={24}>
                        <Form.Item>
                          <button
                            onClick={this.handleSubmit}
                            disabled={this.isLoginDisabled}
                            className={
                              this.state.isLoginDisabled
                                ? "loginButton disabled"
                                : "loginButton"
                            }
                          >
                            <span className="loginButtonText">LOGIN</span>
                            <span>
                              <img
                                src={ArrowIcon}
                                width="20"
                                height="16"
                                alt="Arrow Icon"
                              />
                            </span>
                          </button>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row>{/* <div className="OR_Seperator">OR</div> */}</Row>
                    {/* <Row>
                    <Col span={24}>
                      <Form.Item>
                        <button
                          onClick={() => console.log('Register clicked...')}
                          className="loginButton"
                        >
                          <span className="loginButtonText">Register</span>
                          <span>
                            <img
                              src={ArrowIcon}
                              width="20"
                              height="16"
                              alt="Arrow Icon"
                            />
                          </span>
                        </button>
                      </Form.Item>
                    </Col>
                  </Row> */}
                    {/* {sessionStorage.getItem("planName") === "ultimate" && ( */}
                    <a
                      className="login-form-forgot OR_Seperator"
                      onClick={this.handleRegisterClick}
                      href="#"
                    >
                      Register Now
                    </a>
                    {/* )} */}
                  </Form>
                </div>
                <br />
                {this.state.loader === true &&
                  this.state.redirect === false && (
                    <div className="progress">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        aria-valuenow="100"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style={{ width: "100%" }}
                      >
                        <b>Processing...</b>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>
          <Forgotmodal onClose={this.showModel} show={this.state.show} />

          <Modal
            title="Terms Of Usage"
            visible={this.state.visible}
            closable={false}
            style={{ fontFamily: "Montserrat" }}
            footer={[
              <button
                className="btn btn-outline-dark"
                style={{
                  borderRadius: "20px",
                  fontSize: "1em",
                }}
                onClick={this.handleCancelDisclaimer}
              >
                I Decline
              </button>,
              <button
                className="btn btn-primary"
                onClick={this.handleOkDisclaimer}
                style={{
                  borderRadius: "20px",
                  fontSize: "1em",
                  fontWeight: "700",
                }}
              >
                I Accept
              </button>,
            ]}
          >
            <p>
              <mark>
                DISCLAIMER: The information contained in this portal may contain
                confidential and personal information, including patient
                information which is protected by federal and state privacy
                laws. It is intended only for use in claims payment and is
                intended only for the person with appropriate authorization. If
                you are not the intended recipient, or do not have the
                appropriate authorization, you are hereby notified that any
                review, dissemination, distribution, or duplication of this
                information is strictly prohibited. If you are not the intended
                recipient or do not have authorization, please log out
                immediately and report incident to your immediate supervisor.
              </mark>
            </p>
          </Modal>
        </div>
      </>
    );
  }
}

export default Form.create({ name: "Login" })(Login);
